import React from 'react';
import { View, Text } from '@react-pdf/renderer';
import { OperationType } from 'components/RecordsListView/constants';
import { OrientationOptions } from 'screens/Applications&WorkOrders/Hooks/useOperationPdf';
import { FlexTableProps } from '../../components/FlexTable/types';
import { displayText, formatTextWithSmartLineBreaks } from '../formatHelpers';
import { Locale } from '../../locales';

const getApplicatorFlexHeaderItems = (locale: Locale) => [
  { label: locale.applicators.name, styles: { width: '33%' } },
  { label: locale.applicators.license, styles: { width: '33%' } },
  { label: locale.applicators.company, styles: { width: '33%' } }
];

// eslint-disable-next-line import/prefer-default-export
export const getApplicatorTableRows = (
  applicators: any[] | undefined,
  locale: Locale,
  operationType: OperationType = OperationType.APPLICATION,
  orientation: OrientationOptions = 'portrait'
): FlexTableProps['tableRows'] => {
  const applicatorRows: FlexTableProps['tableRows'] = (applicators?.length
    ? applicators
    : [{}]
  ).map((applicator: any) => {
    const name = {
      key: locale.applicators.name,
      label: displayText(applicator.personName),
      styles: { width: '33%' }
    };

    const licenseNumber = formatTextWithSmartLineBreaks(
      displayText(applicator.licenseNumber),
      orientation === 'landscape' ? 50 : 32
    );

    const license = {
      key: locale.applicators.license,
      label: applicator.expirationDate ? (
        <View>
          <Text>{licenseNumber}</Text>
          <Text
            style={{
              fontFamily: 'Noto Sans',
              fontSize: 9,
              color: '#4D5165'
            }}
          >
            {locale.applicators.expires}: {applicator.expirationDate}
          </Text>
        </View>
      ) : (
        licenseNumber
      ),
      styles: { width: '33%' }
    };

    const company = {
      key: locale.applicators.company,
      label: displayText(applicator.companyName),
      styles: { width: '33%' }
    };

    return [name, license, company];
  });

  const inputRow = [
    {
      key: locale.applicators.name,
      label: '',
      styles: { width: '33%' }
    },
    {
      key: locale.applicators.license,
      label: '',
      styles: { width: '33%' }
    },
    {
      key: locale.applicators.company,
      label: '',
      styles: { width: '33%' }
    }
  ];

  const isWorkOrder = operationType === OperationType.WORK_ORDER;

  const getInputRows = (): FlexTableProps['tableRows'] => {
    if (!isWorkOrder) return [];
    if (applicators === undefined || applicators.length === 0)
      return [inputRow, inputRow];
    return [inputRow];
  };

  const hasApplicators = Array.isArray(applicators) && applicators.length > 0;

  return [
    getApplicatorFlexHeaderItems(locale),
    ...(isWorkOrder && !hasApplicators ? [] : applicatorRows ?? []),
    ...getInputRows()
  ];
};
